import { render, staticRenderFns } from "./edit-handleContent.vue?vue&type=template&id=08de1d19&"
import script from "./edit-handleContent.vue?vue&type=script&lang=ts&"
export * from "./edit-handleContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports